(() => {
  const JUDGE_SELECTOR = '.jdgm-cards-carousel, .jdgm-carousel-wrapper, [class*="jdgm"][class*="carousel"], [class*="jdgm"][class*="medal"]';
  const NATIVE_ARROW_SELECTORS = {
    prev: [
      '.jdgm-carousel__left-arrow',
      '.jdgm-carousel-left-arrow',
      '.jdgm-carousel__prev',
      '.jdgm-carousel-prev',
      '.slick-prev',
      '[class*="jdgm"][class*="left-arrow"]',
      '[class*="jdgm"][class*="prev"]'
    ],
    next: [
      '.jdgm-carousel__right-arrow',
      '.jdgm-carousel-right-arrow',
      '.jdgm-carousel__next',
      '.jdgm-carousel-next',
      '.slick-next',
      '[class*="jdgm"][class*="right-arrow"]',
      '[class*="jdgm"][class*="next"]'
    ]
  };

  const isVisible = (element) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  };

  function getDirection(element) {
    const signature = [
      element.className,
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.getAttribute('data-direction'),
      element.getAttribute('name')
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    if (/(prev|previous|left|back|vorher|zurück|zurueck)/i.test(signature)) return 'prev';
    if (/(next|right|forward|weiter|näch|naech)/i.test(signature)) return 'next';
    return '';
  }

  function getJudgeSections() {
    const sections = new Set();
    document.querySelectorAll(JUDGE_SELECTOR).forEach((node) => {
      // Nur die eigenständigen Judge.me-Karussells/Medal-Widgets bearbeiten.
      // Medaillen innerhalb des Produkt-Bewertungswidgets dürfen NICHT dazu führen,
      // dass die komplette Produktsektion als Startseiten-Judge.me-Sektion markiert wird.
      const insideProductReviewWidget = node.closest(
        '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg'
      );
      const insideCardsCarousel = node.matches('.jdgm-cards-carousel') || node.closest('.jdgm-cards-carousel');
      if (insideProductReviewWidget && !insideCardsCarousel) return;

      const section = node.closest('.shopify-section, section, [id^="shopify-section-"]');
      if (section) sections.add(section);
    });
    return [...sections];
  }

  function makeArrowSvg(direction) {
    const span = document.createElement('span');
    span.className = 'dfn-judgeme-arrow__glyph';

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', direction === 'prev' ? 'M15 5.5 8.5 12 15 18.5' : 'm9 5.5 6.5 6.5L9 18.5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '3.2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    span.appendChild(svg);
    return span;
  }

  function isInvalidJudgeArrowCandidate(element) {
    if (!element) return true;
    return Boolean(
      element.matches('.jdgm-prev-badge, .jdgm-prev-badge__stars, .jdgm-prev-badge__text') ||
      element.closest('.jdgm-preview-badge, .dfn-rating-preview, .dfn-fellnasen-rating-preview') ||
      element.matches('[data-average-rating][data-number-of-reviews]')
    );
  }

  function findNativeArrow(section, direction) {
    for (const selector of NATIVE_ARROW_SELECTORS[direction]) {
      const candidate = [...section.querySelectorAll(selector)].find(
        (element) =>
          !element.classList.contains('dfn-judgeme-custom-arrow') &&
          !isInvalidJudgeArrowCandidate(element) &&
          isVisible(element)
      );
      if (candidate) return candidate;
    }

    return [...section.querySelectorAll('button, a, [role="button"], span, div')].find(
      (candidate) =>
        !candidate.classList.contains('dfn-judgeme-custom-arrow') &&
        !isInvalidJudgeArrowCandidate(candidate) &&
        getDirection(candidate) === direction &&
        isVisible(candidate)
    );
  }

  function restoreMisidentifiedReviewBadges(section) {
    section.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
      badge.classList.remove(
        'dfn-judgeme-circle-control',
        'dfn-judgeme-circle-control--prev',
        'dfn-judgeme-circle-control--next',
        'dfn-judgeme-native-arrow'
      );
      badge.querySelectorAll(':scope > .dfn-judgeme-arrow__glyph').forEach((glyph) => glyph.remove());
    });
  }

  function decorateNativeArrow(arrow, direction) {
    if (!arrow) return false;
    arrow.classList.remove('dfn-judgeme-native-arrow');
    arrow.classList.add('dfn-judgeme-circle-control', `dfn-judgeme-circle-control--${direction}`);
    if (getComputedStyle(arrow).position === 'static') arrow.style.setProperty('position', 'relative', 'important');
    arrow.querySelectorAll(':scope > .dfn-judgeme-arrow__glyph').forEach((glyph, index) => {
      if (index > 0) glyph.remove();
    });
    if (!arrow.querySelector(':scope > .dfn-judgeme-arrow__glyph')) {
      arrow.appendChild(makeArrowSvg(direction));
    }
    return true;
  }

  function cleanJudgeSummary(section) {
    const walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      if (node.parentElement?.closest('script, style')) return;
      node.nodeValue = node.nodeValue.replace(/(\d+[.,]\d+)\s*[★☆]\s*(\(\s*\d+\s*\))/g, '$1 $2');
    });

    section.querySelectorAll('span, div, b, strong').forEach((element) => {
      if (/^[★☆]$/.test(element.textContent.trim())) element.classList.add('dfn-judgeme-summary-star');
    });
  }

  function markJudgeRating(section) {
    section.querySelectorAll('span, div, p, a').forEach((element) => {
      const text = element.textContent?.trim() || '';
      if (!/^\d+\s+Bewertungen$/i.test(text)) return;
      if ([...element.children].some((child) => child.textContent?.trim() === text)) return;

      element.classList.add('dfn-judgeme-review-count');
      let row = element.parentElement;
      for (let depth = 0; row && depth < 4; depth += 1, row = row.parentElement) {
        const symbols = row.querySelectorAll('.jdgm-star, [class*="star"], [class*="heart"]');
        if (!symbols.length) continue;
        row.classList.add('dfn-judgeme-rating-line');
        symbols.forEach((symbol) => symbol.classList.add('dfn-judgeme-rating-symbol'));
        break;
      }
    });
  }


  function directText(element) {
    return [...element.childNodes]
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .map((node) => node.nodeValue || '')
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function markCardsCarouselLayout(section) {
    const carousel = section.querySelector('.jdgm-cards-carousel');
    if (!carousel) return;

    carousel.classList.add('dfn-judgeme-cards-carousel');

    const headings = [...carousel.querySelectorAll('h1, h2, h3')];
    const title =
      headings.find((heading) =>
        /(was unsere|fellnasen-familie|customers are saying|customers say|kunden)/i.test(
          heading.textContent?.trim() || ''
        )
      ) || headings[0];

    if (!title) return;
    title.classList.add('dfn-judgeme-cards-title');

    const rating = [...carousel.querySelectorAll('span, div, p, a')].find((element) => {
      if (element.closest('.jm-review-item')) return false;
      const text = directText(element) || element.textContent?.trim() || '';
      return /^\d+[.,]\d+\s*\(\s*\d+\s*\)$/.test(text);
    });

    if (rating) {
      rating.classList.add('dfn-judgeme-cards-rating');
      const ratingRow = rating.parentElement;
      if (ratingRow && !ratingRow.closest('.jm-review-item')) {
        ratingRow.classList.add('dfn-judgeme-cards-rating-row');
      }
    }

    let header = title.parentElement;
    if (rating) {
      let candidate = title.parentElement;
      while (candidate && candidate !== carousel) {
        const containsReviewCard = Boolean(candidate.querySelector('.jm-review-item'));
        if (candidate.contains(rating) && !containsReviewCard) {
          header = candidate;
          break;
        }
        candidate = candidate.parentElement;
      }
    }

    if (header && header !== carousel && !header.querySelector('.jm-review-item')) {
      header.classList.add('dfn-judgeme-cards-header');
    }
  }

  function enhanceJudgeMe() {
    // Sicherheitsnetz: Falls eine jdgm-prev-badge durch eine vorherige Script-Version
    // bereits als Pfeil markiert wurde, beim Initialisieren sofort zurücksetzen.
    restoreMisidentifiedReviewBadges(document);

    const sections = getJudgeSections();
    document.body.classList.toggle('dfn-has-judgeme-footer', sections.length > 0);

    let arrowsReady = false;
    sections.forEach((section) => {
      section.classList.add('dfn-home-judgeme-section');
      markCardsCarouselLayout(section);
      section.querySelectorAll(':scope > .dfn-judgeme-custom-arrow').forEach((arrow) => arrow.remove());
      cleanJudgeSummary(section);
      markJudgeRating(section);

      const prev = findNativeArrow(section, 'prev');
      const next = findNativeArrow(section, 'next');
      const prevReady = decorateNativeArrow(prev, 'prev');
      const nextReady = decorateNativeArrow(next, 'next');
      arrowsReady = arrowsReady || (prevReady && nextReady);
    });

    return sections.length > 0 && arrowsReady;
  }

  function getBrandArrowCenter(direction) {
    const arrow = document.querySelector(`.brand-slider-section .brand-slider-btn--${direction}`);
    if (!isVisible(arrow)) return null;
    const rect = arrow.getBoundingClientRect();
    return rect.left + rect.width / 2;
  }

  function alignProductCarouselArrows() {
    const brandPrevCenter = getBrandArrowCenter('prev');
    const brandNextCenter = getBrandArrowCenter('next');

    document.querySelectorAll('.has-edge-arrows').forEach((carousel) => {
      const prev = carousel.querySelector('.edge-button--prev');
      const next = carousel.querySelector('.edge-button--next');
      if (!prev || !next) return;

      [
        ['prev', prev, brandPrevCenter],
        ['next', next, brandNextCenter]
      ].forEach(([direction, arrow, brandCenter]) => {
        if (!isVisible(arrow)) return;
        const parent = arrow.offsetParent;
        if (!parent) return;

        const parentRect = parent.getBoundingClientRect();
        const arrowRect = arrow.getBoundingClientRect();
        const scaleX = parent.offsetWidth > 0 ? parentRect.width / parent.offsetWidth : 1;
        const fallbackCenter =
          direction === 'prev' ? 18 + arrowRect.width / 2 : window.innerWidth - 18 - arrowRect.width / 2;
        const targetCenter = brandCenter ?? fallbackCenter;
        const localLeft = (targetCenter - parentRect.left) / (scaleX || 1) - arrow.offsetWidth / 2;

        arrow.style.setProperty('left', `${localLeft}px`, 'important');
        arrow.style.setProperty('right', 'auto', 'important');
        arrow.style.setProperty('margin', '0', 'important');
      });
    });
  }

  let scheduled = false;
  function refreshEnhancements() {
    const ready = enhanceJudgeMe();
    alignProductCarouselArrows();
    return ready;
  }

  function scheduleEnhancement() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      refreshEnhancements();
    });
  }

  function start() {
    refreshEnhancements();
    [120, 350, 800, 1600, 3000].forEach((delay) => window.setTimeout(scheduleEnhancement, delay));

    const observer = new MutationObserver((records) => {
      const relevant = records.some((record) =>
        [...record.addedNodes].some((node) => {
          if (!(node instanceof Element)) return false;
          return node.matches?.('[class*="jdgm"], [id*="jdgm"]') || node.querySelector?.('[class*="jdgm"], [id*="jdgm"]');
        })
      );
      if (relevant) scheduleEnhancement();
    });

    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('load', scheduleEnhancement, { once: true });
  window.addEventListener('pageshow', scheduleEnhancement);
  window.addEventListener('resize', scheduleEnhancement, { passive: true });
  document.addEventListener('shopify:section:load', scheduleEnhancement);
})();
